import { useState } from "react";

import { useFirebaseListFunction, useFirebaseSubscription } from "hooks";
import firebase, { FunctionCall } from "firebaseFactory";
import { DeviceReference, DeviceByTypeData } from "modules/devices";

export const useDevicesByUnit = (
  siteId: string,
  getDevicesBySiteId: FunctionCall
) => {
  // this are all the same as geting the data by unitId, we're just filtering down again
  const { data: devices, isLoading } = useFirebaseListFunction<DeviceReference>(
    getDevicesBySiteId,
    { siteId }
  );

  return { devicesByUnit: getDevicesByUnit(devices), isLoading };
};

export const getDevicesByUnit = (devices: DeviceReference[]) => {
  return devices.reduce((devicesByUnit, device) => {
    (devicesByUnit[device.unitId] = devicesByUnit[device.unitId] || []).push(
      device
    );
    return devicesByUnit;
  }, {} as { [unitId: string]: DeviceReference[] });
};

export const flattenSiteDataByUnit = (latestDataByUnit: SiteDataByUnit) =>
  Object.values(latestDataByUnit).flatMap((x) => Object.values(x));

export interface SiteDataByUnit {
  [unitId: string]: { [deviceId: string]: DeviceByTypeData };
}

export const useSiteDataByUnit = (siteId: string) => {
  const [latestDataByUnit, setLatestDataByUnit] = useState<SiteDataByUnit>({});

  useFirebaseSubscription<{
    [unitId: string]: { [deviceId: string]: DeviceByTypeData };
  }>(
    firebase.shards.Customer,
    `devices/dataBySite/${siteId}/latestByType/data/pack_data`,
    "value",
    (key, data) => setLatestDataByUnit(data || {}),
    []
  );

  return {
    latestDataByUnit,
  };
};
